import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/team/members/{userId}', 'delete'>;
type ResponseBody = OASOutput<O, '/api/team/members/{userId}', 'delete'>;

type Params = {
  userId: number;
};

type Result = {
  userId: number;
};

export const removeTeamMemberFactory = (apiClient: ApiClient) => {
  const removeTeamMember = async (userId: number) => {
    const requestBody = mapInputToRequestBody({ userId });
    const response = await apiClient['/api/team/members/{userId}'].delete(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      params: {
        userId: input.userId,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      userId: response,
    };
  };

  return removeTeamMember;
};
